// extracted by mini-css-extract-plugin
module.exports = {"page":"PhzrBgjj","current":"dWMyFFvP","ellipsis":"MeFj0EPJ"};